import {Component} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';

@Component({
    selector: 'app-child-cell',
    template: `<a [style.visibility]="isPresented ? 'visible' : 'hidden'" rel="nofollow noreferrer noopener" href="javascript:void(0)" (click)="download()">Download</a>`,
    styles: [
        `i:hover {
      cursor: pointer;
    }`,
    ],
    standalone: false
})

export class DownloadButtonRendererComponent implements ICellRendererAngularComp {
  params: any;
  isPresented: boolean = false;

  agInit(params: any): void {
    this.params = params;
    this.isPresented = (this.params.data.filePath.includes('.')) ? true : false;
  }

  download() {
    this.params.onClick(this.params.data);
    console.log(this.params);
  }

  refresh(): boolean {
    return false;
  }
}